import { getWireInstructions, getWireInstructionsLoader } from 'app/state/ducks/wire-instructions/selectors'
import { loadWireInstructions } from 'app/state/ducks/wire-instructions/thunks'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cleanUUID from 'app/views/components/functions/cleanUUID'
import { Stack } from '@mantine/core'
import { WireInstructionParams } from 'app/models/wire-instruction-params'
import MainTable from 'app/views/components/Table/MainTable'
import { WireInstructionsModal } from './modal-wire-instructions'
import { wireInstructionCols } from './wire-instructions-columnDefs'
import { getBusinessDate } from 'app/state/ducks/business-date/selectors'
import {
  GridSortingStorage,
  GridPaginationStorage,
  GridColumnVisibilityStorage,
  useGridSorting,
  useGridPagination,
  useGridColumnVisibility,
} from 'app/utils/grid-sorting-storage'

interface Props {
  entityId?: string
}

export default function ManageEntityWireInstructions({ entityId }: Props) {
  // Grid preferences hooks
  const { sorting, handleSortingChange } = useGridSorting(GridSortingStorage.entityWireInstructions)
  const { pagination, handlePaginationChange } = useGridPagination(GridPaginationStorage.entityWireInstructions)
  const { columnVisibility, handleColumnVisibilityChange } = useGridColumnVisibility(GridColumnVisibilityStorage.entityWireInstructions)

  const dispatch = useDispatch()
  const wireInstructions: WireInstructionParams[] =
    useSelector(getWireInstructions)
  const wireInstructionsLoader = useSelector(getWireInstructionsLoader)
  const [globalLoading, setGlobalLoading] = useState(false)
  const [addWireInstructions, setAddWireInstructions] = useState<boolean>(false)
  const [wireInstruction, setWireInstruction] = useState<
    undefined | WireInstructionParams
  >(undefined)
  const businessDate = useSelector(getBusinessDate)

  useEffect(() => {
    setGlobalLoading(wireInstructionsLoader)
  }, [wireInstructionsLoader])

  useEffect(() => {
    dispatch(loadWireInstructions())
  }, [])

  if (!entityId) {
    return <></>
  }


  return (
    <Stack w="100%">
      {wireInstructions ? (
        <MainTable
          tableName='Wire_Instructions Table'
          isLoading={globalLoading}
          enableTopToolbar={false}
          csvExportEnabled={true}
          enableGrouping={true}
          fromWireInstructions={true}
          headerBackgroundColor='#F0EEEE'
          data={wireInstructions.filter(
            p => cleanUUID(p?.entity?.id) === entityId
          ) ?? []}
          columnDefs={wireInstructionCols(businessDate)}
          initialSorting={[{ id: sorting.sortBy, desc: sorting.order === 'desc' }]}
          onSortingChange={handleSortingChange}
          initialPagination={pagination}
          onPaginationChange={handlePaginationChange}
          initialColumnVisibility={columnVisibility}
          onColumnVisibilityChange={handleColumnVisibilityChange}
          setRow={(e: WireInstructionParams, cellName: string) => {
            if (cellName != 'id') {
              setWireInstruction(e)
              setAddWireInstructions(true)
            }
          }}
          border
          controlSectionBorder={false}
        />
      ) : null}

      <WireInstructionsModal
        setOpen={setAddWireInstructions}
        open={addWireInstructions}
        paymentInstruction={wireInstruction}
      />
    </Stack>
  )
}
